import * as yup from 'yup'
import { MAX_CHAT_TITLE_LENGTH } from 'constants/chat'

const EditChatSchema = yup.object().shape({
  title: yup.string()
    .trim()
    .required('aiChat.history.titleRequired')
    .max(MAX_CHAT_TITLE_LENGTH, 'aiChat.history.titleTooLong'),
})

export { EditChatSchema }
